import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type { GetSuiteScriptsResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  assetId: string
  children?: (data: GetSuiteScriptsResponse) => ReactElement
  onSuccess?: (data: GetSuiteScriptsResponse) => void
}

const GetVamSuiteScriptsRequest = ({
  assetId,
  children,
  onSuccess
}: Props) => {
  const url = `${VAM_SERVICE}/suites/${assetId}/scripts`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetVamSuiteScriptsRequest
